import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { IconComponent } from './icon/icon.component';
import { MenuHelpComponent } from './header/menu-help/menu-help.component';
import { MenuUserComponent } from './header/menu-user/menu-user.component';
import { MenuVentaComponent } from './header/menu-venta/menu-venta.component';
import { ModalComponent } from './modal/modal.component';
import { ModalPasswordComponent } from './modal-password/modal-password.component';
import { ModalPolicyPrivacyComponent } from './modal-policy-privacy/modal-policy-privacy.component';
import { ModalTermsConditionsComponent } from './modal-terms-conditions/modal-terms-conditions.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { StorybookModule } from '@app/storybook.module';
import { ModalCloseSessionComponent } from './modal-close-session/modal-close-session.component';
import { ModalContactFormComponent } from './modal-contact-form/modal-contact-form.component';
import { SanitizePipe } from '@shared/pipes/sanitize.pipe';
import { NewUserComponent } from './new-user/new-user.component';
import { UpdateUserComponent } from './update-user/update-user.component';
import { ModalRecoverEmailComponent } from './modal-recover-email/modal-recover-email.component';
import { ModalTourComponent } from './modal-tour/modal-tour.component';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { CreateAccountComponent } from './create-account/create-account.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

const component: any[] = [
  CreateAccountComponent,
  FooterComponent,
  HeaderComponent,
  IconComponent,
  MenuHelpComponent,
  MenuUserComponent,
  MenuVentaComponent,
  ModalComponent,
  ModalPasswordComponent,
  ModalPolicyPrivacyComponent,
  ModalTermsConditionsComponent,
  SpinnerComponent,
  ModalContactFormComponent,
  NewUserComponent,
  UpdateUserComponent,
  ModalRecoverEmailComponent,
  ModalTourComponent,
  ChangePasswordComponent,
];

@NgModule({
  declarations: [component, ModalCloseSessionComponent, SanitizePipe],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    StorybookModule,
    RecaptchaFormsModule,
    RecaptchaModule,
  ],
  exports: [component],
  providers: [],
})
export class ComponentModule {}
